import { CopyOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Input, Popconfirm, Space, Typography } from 'antd';
import VoucherModal from 'components/voucher/add-edit';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';

const { Search } = Input;
const { Text } = Typography;

const VoucherListMobile = ({ viewModel }) => {
  const {
    data,
    isModalOpen,
    voucherID,
    setIsModalOpen,
    openVoucher,
    onSearch,
    onSearchChange,
    onVoucherSaved,
    copyVoucherCode,
    deleteVoucher,
  } = viewModel;

  return (
    <>
      <Space direction='vertical' size={16} style={{ width: '100%' }}>
        <Card style={{ width: '100%' }}>
          <Space direction='vertical' size={8} style={{ width: '100%' }}>
            <Search
              placeholder='Voucher'
              onSearch={onSearch}
              style={{ width: '100%' }}
              onChange={onSearchChange}
            />
            <Flex justify='flex-end' style={{ width: '100%' }}>
              <Button type='primary' onClick={() => openVoucher(null)}>Thêm mới</Button>
            </Flex>
          </Space>
        </Card>

        <Card style={{ width: '100%' }}>
          <Space direction='vertical' size={8} style={{ width: '100%' }}>
            {(data || []).map((record) => (
              <Card key={record.id} bodyStyle={{ padding: 12 }}>
                <Space direction='vertical' size={8} style={{ width: '100%' }}>
                  <Flex justify='space-between' align='center' gap={8}>
                    <Text strong ellipsis={{ tooltip: record.code }} style={{ minWidth: 0 }}>
                      {record.code}
                    </Text>
                    <Text type='secondary'>{formatDate(record.create_on)}</Text>
                  </Flex>

                  <Text type='secondary'>{record.description || '-'}</Text>

                  <Flex justify='space-between' gap={8}>
                    <Text>Giá trị</Text>
                    <Text strong>
                      {record.type === 'fixed'
                        ? formatCurrency(record.value)
                        : `${formatCurrency(record.value)} %`}
                    </Text>
                  </Flex>

                  <Space direction='vertical' size={2} style={{ width: '100%' }}>
                    <Text type='secondary'>Đã sử dụng {record.usages.length} / {record.usage_limit}</Text>
                    {(record.usages || []).map((usage) => (
                      <Text key={usage.order_id} type='secondary'>#{usage.order_id}</Text>
                    ))}
                  </Space>

                  <Flex gap={8} justify='flex-end'>
                    <Button icon={<EditOutlined />} onClick={() => openVoucher(record.id)}>
                      Sửa
                    </Button>
                    <Button icon={<CopyOutlined />} onClick={() => copyVoucherCode(record.code)}>
                      Copy
                    </Button>
                    <Popconfirm
                      title='Xoá'
                      description='Bạn có chắc chăn muốn xoá?'
                      onConfirm={() => deleteVoucher(record.id)}
                      okText='Yes'
                      cancelText='No'
                    >
                      <Button danger icon={<DeleteOutlined />}>
                        Xoá
                      </Button>
                    </Popconfirm>
                  </Flex>
                </Space>
              </Card>
            ))}

            {!data?.length ? (
              <Card style={{ textAlign: 'center' }}>
                <Text type='secondary'>Không có voucher nào</Text>
              </Card>
            ) : null}
          </Space>
        </Card>
      </Space>

      <VoucherModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={voucherID}
        onSaved={onVoucherSaved}
      />
    </>
  );
};

export default VoucherListMobile;